<template>
    <div class="upgrade-needed-page" :class="{ limited: limited }">
        <div class="upgrade-needed-page-title">
            <div class="upgrade-needed-page-image">
                <UpgradeSVG />
            </div>
            <div v-if="limited">{{ $t("upgradeMessages.usageLimitExceeded") }}</div>
            <div v-else>"{{ getPageName() }}" {{ $t("upgradeMessages.featureNotAvailable") }}</div>
        </div>
        <div class="upgrade-needed-page-description">
            {{ getPageDescription() }}
        </div>
        <div class="upgrade-needed-page-subscription">
            <SupsisButton @click="upgrade" primary>{{ $t("upgradeMessages.upgrade") }}</SupsisButton>
            <SupsisButton @click="upgradeFeature" ghost v-if="feature && !limited">{{
                $t("upgradeMessages.upgradeFeature")
            }}</SupsisButton>
        </div>
    </div>
</template>
<script>
import Modal from "../common/Modal2.vue";
import UpgradeSVG from "../svg/Upgrade.vue";
import UpgradeIconSvg from "./svg/UpgradeIconSvg.vue";
import SupsisButton from "../../views/Pages/Settings/components/SupsisButton.vue";

export default {
    name: "UpgradeNeededPageOverlay",
    props: {
        plan: {
            type: String,
            default: null,
        },
        feature: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: null,
        },
        limited: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        SupsisButton,
        UpgradeIconSvg,
        Modal,
        UpgradeSVG,
    },
    data: function () {
        return {
            pageNames: {
                ticket: this.$t("search.ticket"),
                tasks: this.$t("message.taskModule"),
                calendar: this.$t("message.calendarModule"),
                "mail-entegration": this.$t("message.email"),
                "team-integration": this.$t("message.teamChat"),
                "webhook-integration": this.$t("plans.webhookIntegration"),
                "whatsapp-v2": this.$t("whatsappChannel.whatsappTitleV2"),
                whatsapp: this.$t("whatsappChannel.whatsappTitleV2"),
                "whatsapp-business-api": this.$t("whatsappChannel.whatsappTitleV2"),
                instagram: this.$t("plans.instagramIntegration"),
                messenger: this.$t("messenger.integrationTitle"),
                "sms-postacell": this.$t("plans.smsIntegration"),
                "ready-contents": this.$t("plans.readyContents"),
                automation: this.$t("message.automationIntegration"),
                form: this.$t("message.formIntegration"),
                "customer-tables": this.$t("message.customerTables"),
                trendyol: this.$t("message.trendyolIntegration"),
                "access-control": this?.$t("settings.accessControl") || "Erişim Kontrolü",
            },
            pageDescriptions: {
                ticket: this.$t("upgradeMessages.ticket"),
                tasks: this.$t("upgradeMessages.tasks"),
                calendar: this.$t("upgradeMessages.calendar"),
                "mail-entegration": this.$t("upgradeMessages.mail_integration"),
                "team-integration": this.$t("upgradeMessages.team_integration"),
                "webhook-integration": this.$t("upgradeMessages.webhook_integration"),
                "whatsapp-v2": this.$t("upgradeMessages.whatsapp_v2"),
                whatsapp: this.$t("upgradeMessages.whatsapp"),
                "whatsapp-business-api": this.$t("upgradeMessages.whatsapp_business_api"),
                instagram: this.$t("upgradeMessages.instagram"),
                messenger: this.$t("upgradeMessages.messenger"),
                "sms-postacell": this.$t("upgradeMessages.sms_postacell"),
                "ready-contents": this.$t("upgradeMessages.ready_contents"),
                automation: this.$t("upgradeMessages.automation"),
                form: this.$t("upgradeMessages.form"),
                "customer-tables": this.$t("upgradeMessages.customer_tables"),
                trendyol: this.$t("upgradeMessages.trendyol"),
                "access-control": this.$t("upgradeMessages.access_control"),
            },
            limitedDescription: {
                mail: "E-posta gönderme limitiniz dolmuştur. Tekrar e-posta gönderebilmek ve alabilmek için aboneliğinizi yükseltmelisiniz.",
            },
        }
    },
    methods: {
        getPageName() {
            return (
                this.pageNames[this.name] ||
                this.pageNames[this.$route.name] ||
                this.pageNames[this.plan] ||
                this.pageNames[this.feature]
            );
        },
        getPageDescription() {
            return this.limited
                ? this.limitedDescription[this.name] ||
                this.limitedDescription[this.$route.name] ||
                this.limitedDescription[this.plan] ||
                this.limitedDescription[this.feature]
                : this.pageDescriptions[this.name] ||
                this.pageDescriptions[this.$route.name] ||
                this.pageDescriptions[this.plan] ||
                this.pageDescriptions[this.feature];
        },
        upgrade() {
            this.$router.push(`/billing/plans/${this.plan}`);
        },
        upgradeFeature() {
            this.$router.push(`/billing/plans/${this.feature}`);
        },
    },
};
</script>
<style lang="scss">
.upgrade-needed-page {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 40px;
    padding: 40px;
    background: white;

    &.limited {
        z-index: 9999999;
        background: rgba(245, 245, 245, 0.61);
    }

    &-image {
        width: 500px;

        svg {
            width: 100%;
            height: 100%;
        }
    }

    &-title {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        font-size: 28px;
        font-weight: bold;
    }

    &-description {
        font-size: 18px;
        text-align: center;
    }

    &-subscription {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
    }
}
</style>
